export const SkillsData = [
    {
      type: "Frontend",
      list: [
        {
          name: "HTML",
          icon: <i class="devicon-html5-plain colored"></i>,
          },
          {
            name: "CSS",
            icon:<i class="devicon-css3-plain colored"></i>,
        },
        {
          name: "Javascript",
          icon: <i class="devicon-javascript-plain colored"></i>,
        },
        
        {
          name: "ReactJS",
          icon: <i class="devicon-react-original colored"></i>,
        },
      
        
      
     
      ],
    },
    {
      type: "Backend",
      list: [
        {
          name: "MongoDB",
          icon: <i class="devicon-mongodb-plain colored"></i>,
        },
        {
          name: "NodeJS",
          icon: <i class="devicon-nodejs-plain colored"></i>,
        },
      ],
    },
  ];